import { Stack } from '@mui/material';
import React, { useState } from 'react';
import TurnInfo from './TurnInfo/TurnInfo';
import DateRanges from './DateRanges/DateRanges';
import DaysTimes from './DaysTimes/DaysTimes';
import i18next from 'i18next';

const OtherTurns = ({ turnBaseData }) => {
  const [range, setRange] = useState(null);

  console.log('i18next===>',i18next.language)
  return (
    <React.Fragment>
      <Stack gap=".5em">
        <TurnInfo turnBaseData={turnBaseData} />
        <DateRanges setRange={setRange} />
        <DaysTimes range={range} />
      </Stack>
    </React.Fragment>
  );
};

export default OtherTurns;
